import React from "react";
import { Instagram, Facebook, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer id="contact" data-testid="footer-section" className="relative bg-black border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h3 className="font-serif text-3xl md:text-4xl text-white tracking-tight">
            Next Bar &amp; <span className="italic text-[#D4AF37]">Lounge</span>
          </h3>
          <p className="mt-6 text-neutral-400 leading-relaxed max-w-md">
            An upscale, intimate lounge on Wilton Drive — devoted to live entertainment and the quiet art of a
            well-mixed drink.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] mb-5">Visit</p>
          <ul className="space-y-3 text-neutral-400 text-sm">
            <li className="flex items-start gap-3"><MapPin size={14} className="mt-1 text-[#D4AF37]" /><span>2242 Wilton Dr<br />Wilton Manors, FL</span></li>
            <li className="flex items-center gap-3"><Phone size={14} className="text-[#D4AF37]" /><a href="tel:+19542617295" className="hover:text-[#D4AF37]" data-testid="footer-phone">954-261-7295</a></li>
            <li className="flex items-center gap-3"><Mail size={14} className="text-[#D4AF37]" /><a href="mailto:nextventures2025@gmail.com" className="hover:text-[#D4AF37]" data-testid="footer-email">nextventures2025@gmail.com</a></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] mb-5">Follow</p>
          <div className="flex gap-4">
            <a href="https://www.instagram.com/nextbarandlounge?igsh=ZnU1ajd1NTcxMTNk&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-10 w-10 border border-neutral-800 hover:border-[#D4AF37] hover:text-[#D4AF37] text-neutral-400 flex items-center justify-center transition-colors" data-testid="social-ig">
              <Instagram size={16} />
            </a>
            <a href="https://www.facebook.com/Nextbarandlounge/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="h-10 w-10 border border-neutral-800 hover:border-[#D4AF37] hover:text-[#D4AF37] text-neutral-400 flex items-center justify-center transition-colors" data-testid="social-fb">
              <Facebook size={16} />
            </a>
            <a href="mailto:nextventures2025@gmail.com" aria-label="Email" className="h-10 w-10 border border-neutral-800 hover:border-[#D4AF37] hover:text-[#D4AF37] text-neutral-400 flex items-center justify-center transition-colors" data-testid="social-mail">
              <Mail size={16} />
            </a>
          </div>
        </div>
      </div>
      <div className="relative overflow-hidden">
        <div className="text-center select-none pb-8">
          <span className="font-serif italic text-white/[0.04] text-[18vw] leading-none tracking-tighter">
            Next Lounge
          </span>
        </div>
        <div className="border-t border-neutral-900 py-6 px-6 md:px-12 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-600">
          <p>© {new Date().getFullYear()} Next Bar &amp; Lounge. All rights reserved.</p>
          <p className="tracking-[0.2em] uppercase">Crafted in shadow &amp; light</p>
        </div>
      </div>
    </footer>
  );
}
